














































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetInterviesExceptCurrentGroup,
  PostCreateCrfs
} from "@/request/projects";
@Component({})
export default class ProjectFangshiAddCrfDialog extends Vue {
  @Prop()
  private visible: any;
  @Prop()
  private interview: any;
  private total: any = 0;
  private crfs: any = [];
  private get ifVisible() {
    return this.visible;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 获得所有可选的CRF量表
   */
  private fetchAllInterviewsExceptCurrentGroup() {
    const load = this.$loading({
      text: "加载中...",
      target: "loadingTarget"
    });
    const params: any = {
      params: {
        interview_id: this.interview.interview_id
      }
    };
    GetInterviesExceptCurrentGroup(this, params)
      .then((data: any) => {
        this.crfs = data.templates;
        this.total = data.total_count;
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 创建一个新的crf
   */
  private addNewCrf() {
    this.$emit("add");
  }
  /**
   * @description 选择一个表单
   */
  private chooseThis(crf) {
    crf.choosed = !crf.choosed;
    this.$forceUpdate();
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.$emit("update:visible", false);
  }
  /**
   * @description 保存
   */
  private save() {
    const arr: any[] = [];
    this.crfs.map((crf: any) => {
      if (crf.choosed) {
        arr.push(crf.template_id);
      }
    });
    const params: any = {
      project_id: this.interview.project_id,
      group_id: this.interview.group_id,
      interview_id: this.interview.interview_id,
      src_template_ids: arr
    };
    PostCreateCrfs(this, params).then((data: any) => {
      this.$message.success("创建成功");
      this.$emit("done");
      this.$emit("update:visible", false);
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$nextTick().then(() => {
      this.fetchAllInterviewsExceptCurrentGroup();
    });
  }
}
